module.exports = __webpack_public_path__ + "38771e71e633ab5ff637d25f84f05d50.png";